/* unplugin-vue-components disabled */import { render } from "./EditorViewer.vue?vue&type=template&id=3c8a4041&scoped=true&ts=true"
import script from "./EditorViewer.vue?vue&type=script&lang=ts"
export * from "./EditorViewer.vue?vue&type=script&lang=ts"

import "./EditorViewer.vue?vue&type=style&index=0&id=3c8a4041&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c8a4041"]])

export default __exports__